'use client';

import type { ConnectorStatus } from '@repo/api-gw-sdk';
import React from 'react';

import {
  StatusIcon,
  type StatusConfig,
} from '@/components/lakehouse/statusIcon';

const connectorStatusConfig: Record<string, StatusConfig> = {
  ACTIVE: {
    title: 'Active',
    iconColor: 'var(--mui-palette-success-main)',
    backgroundColor: 'var(--mui-palette-success-opacity)',
    icon: 'material-symbols-check-circle-outline-rounded',
  },
  INACTIVE: {
    title: 'Inactive',
    iconColor: 'var(--mui-palette-custom-GREY-01)',
    backgroundColor: 'var(--mui-palette-custom-GREY-OPACITY)',
    icon: 'material-symbols-do-not-disturb-on-outline-rounded',
  },
};

export const ConnectorStatusCell = React.forwardRef<
  HTMLSpanElement,
  { status: ConnectorStatus }
>(({ status }, ref) => (
  <StatusIcon ref={ref} status={status} configMap={connectorStatusConfig} />
));

ConnectorStatusCell.displayName = 'ConnectorStatusCell';
